import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedComprobantesAgregarFormularioComponent {
  catalogos
  data
  editable = true
  operadora
  onChange
  onClose
  valido = true

  constructor (ViaticosViaticoComprobanteService) {
    this.ViaticosViaticoComprobanteService = ViaticosViaticoComprobanteService
  }

  $onInit () {
    if (this.data.comprobante_id) {
      this.$promise = this.ViaticosViaticoComprobanteService.get(this.data.comprobante_id)
        .then(({data}) => {
          let dataObj = {
            advertencias: 0,
            data: {
              deducible: data.deducible,
              emisor_nombre: data.emisor_nombre,
              emisor_rfc: data.emisor_rfc,
              fecha: data.fecha,
              folio: data.folio,
              id_categoria: data.id_categoria.padStart(3, '0'),
              id_moneda: data.id_moneda,
              moneda: data.moneda,
              notas: data.notas,
              receptor_nombre: data.receptor_nombre,
              receptor_rfc: data.receptor_rfc,
              serie: data.serie,
              subtotal: data.subtotal,
              tipo_cambio: data.tipo_cambio,
              tipo_comprobante: data.tipo_comprobante,
              tipo_gasto: data.tipo_gasto,
              total: data.total,
              propina: data.propina,
              total_impuestos_retenidos: data.total_impuestos_retenidos,
              total_impuestos_trasladados: data.total_impuestos_trasladados,
              uuid: data.uuid,
              autorizado: data.autorizado,
              preautorizado: data.preautorizado,
            },
            errores: 0,
            mensajes: null,
            pdf: data.pdf,
            xml: data.xml,
          }
          this.data = Object.assign({}, dataObj)
          this.editable = !data.preautorizado && !data.xml
        })
    } else {
      this.editable = !this.data.data.preautorizado
    }
  }

  $onChanges (changes) {
    if (changes.data && this.data.data) {
      this.data = Object.assign({}, this.data)
      this.asignarIdMoneda()
    }
  }

  guardar () {
    if (!this.data.xml) {
      this.data.data.receptor_rfc = this.operadora.rfc
      this.data.data.receptor_nombre = this.operadora.nombre
      this.data.data.subtotal = this.data.data.total
      this.data.data.propina = this.data.data.propina || 0
      this.data.data.total_impuestos_trasladados = 0
      this.data.data.total_impuestos_retenidos = 0
      this.data.data.deducible = false
      this.data.data.serie = ''
      this.data.data.folio = ''
      this.data.data.notas = ''
      this.data.data.uuid = ''
    }
    this.onChange({$event: {detail: this.data}})
  }

  asignarTipoGasto () {
    if (!this.data.data.id_categoria) return
    this.data.data.tipo_gasto = this.catalogos.gasto_categoria.find((item) => item.ID === this.data.data.id_categoria).Descripcion
  }

  asignarIdMoneda () {
    if (!this.data.data.moneda) return
    this.data.data.id_moneda = this.catalogos.moneda.find((item) => item.clave === this.data.data.moneda).moneda_id
  }

  setXML (data) {
    if (!data) return
    this.data.data = data.data
    this.data.xml = data.xml
    this.asignarIdMoneda()
    this.editable = false
  }

  deleteXML () {
    this.data.xml = null
    this.editable = true
  }

  setPDF (file) {
    this.data.pdf = file
  }

  deletePDF () {
    this.data.pdf = null
  }

  cancelar () {
    this.onClose({$event: {detail: null}})
  }
}

module.component('viaticosSharedComprobantesAgregarFormulario', {
  controller: ViaticosSharedComprobantesAgregarFormularioComponent,
  template,
  bindings: {
    catalogos: '<',
    data: '<',
    operadora: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/comprobantes/agregar/formulario/component.js